var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    clipRule: "evenodd",
    fillRule: "evenodd",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 400 357",
    style: {
      fill: "rgb(69, 125, 88)"
    },
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M128 201c-24,-19 -44,-45 -57,-73 35,9 67,28 90,56 3,13 8,25 16,37 -14,-11 -31,-18 -49,-20l0 0zm96 87c4,10 3,21 -2,31 -5,9 -15,16 -26,18 13,1 24,-5 30,-16 6,-11 5,-24 -2,-33l0 0zm-54 -11l20 -22c-176,38 -129,-105 10,-9 84,-160 -84,-160 0,0 138,-96 185,47 9,9l20 22c17,16 17,43 0,59 -16,16 -42,16 -59,0 -16,-16 -16,-43 0,-59l0 0zm0 -12c0,0 0,0 0,0l-6 6c-19,19 -19,51 0,71 20,19 52,19 71,0 20,-20 20,-52 0,-71l-5 -6c0,0 0,0 -1,0 60,18 127,-1 171,-46 -31,-14 -64,-21 -98,-21 34,-26 57,-63 67,-105 -49,2 -94,25 -125,63 3,-56 -13,-110 -44,-156 -31,46 -47,100 -44,156 -31,-38 -77,-61 -125,-63 10,42 33,79 66,105 -33,0 -67,7 -97,21 43,45 111,64 170,46l0 0zm101 -64c25,-19 45,-45 58,-73 -35,9 -67,28 -91,56 -2,13 -8,25 -15,37 14,-11 31,-18 48,-20l0 0z",
    style: {
      fill: "inherit"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5ff7cfb29aaed63d49f7dab1460665b0.svg";
export { ForwardRef as ReactComponent };